/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { metricsGetApiV3MetricsLastRewardEvent } from "../../funcs/metricsGetApiV3MetricsLastRewardEvent.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetApiV3MetricsLastRewardEventRequest$inboundSchema
    .optional(),
};

export const tool$metricsGetApiV3MetricsLastRewardEvent: ToolDefinition<
  typeof args
> = {
  name: "metrics-get-api-v3-metrics-last-reward-event",
  description: ``,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await metricsGetApiV3MetricsLastRewardEvent(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
